"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const httpRepository_1 = __importDefault(require("./httpRepository"));
const CompanyRepository = {
    saveCompanyName: ({ companyName }) => httpRepository_1.default.tradeshiftGo().put('/rest/company/companyName', { companyName }),
    getCompanyFeatures: () => httpRepository_1.default.tradeshiftGo()
        .get('/rest/features')
        .then(response => response.data),
    saveCompanyFeature: ({ key, value }) => httpRepository_1.default.tradeshiftGo().put(`/rest/features/${key}`, `${value}`),
    getCompanyProperty: ({ companyAccountId, propertyKey }) => httpRepository_1.default.tradeshiftGo()
        .get(`/rest/company/${companyAccountId}/properties/${propertyKey}`)
        .then(response => response.data),
    saveCompanyProperty: ({ companyId, key, value }) => httpRepository_1.default.tradeshiftGo().put(`/rest/company/${companyId}/properties/${key}`, {
        propertyKey: key,
        propertyValue: value,
    }),
    getCompanyPropertyWhitelistedDomains: ({ companyId }) => httpRepository_1.default.tradeshiftGo()
        .get(`/rest/company/${companyId}/whitelisteddomains/`)
        .then(response => response.data),
    saveCompanyPropertyWhitelistedDomain: ({ companyId, domain }) => httpRepository_1.default.tradeshiftGo().post(`/rest/company/${companyId}/whitelisteddomains`, { newDomain: domain }),
    deleteCompanyPropertyWhitelistedDomain: ({ companyId, domain }) => httpRepository_1.default.tradeshiftGo().delete(`/rest/company/${companyId}/whitelisteddomains`, {
        data: { domain },
    }),
    getCompanyUsers: async (params) => {
        const response = await httpRepository_1.default.tradeshiftGo().get('/rest/company/users', { params });
        return response.data;
    },
};
exports.default = CompanyRepository;
